import React from "react";
import { X, Upload } from "lucide-react";
import { loadImage } from "../../services/uiService";

const MapiToolbar = ({ onDelete, onExport, isLoading = false }) => {
  const loadingIcon = loadImage("loading_continuous.gif");
  const iconClass = "h-5 w-5";
  const buttonBaseClass =
    "flex items-center justify-center p-2 rounded transition-all duration-200";
  const enabledClass =
    "hover:bg-customLightBlue text-customBlue cursor-pointer";
  const disabledClass = "text-lightgray cursor-not-allowed opacity-50";

  const getButtonClass = (isEnabled) => {
    return `${buttonBaseClass} ${isEnabled ? enabledClass : disabledClass}`;
  };

  const isDeleteEnabled = onDelete && !isLoading;
  const isExportEnabled = onExport && !isLoading;

  const handleDelete = () => {
    if (isDeleteEnabled && onDelete) {
      onDelete();
    }
  };

  const handleExport = () => {
    if (isExportEnabled && onExport) {
      onExport();
    }
  };

  return (
    <div className="flex justify-end absolute -top-[0rem] right-0 z-10">
      <div className="flex items-center justify-end gap-1 px-2 py-1 mb-0">
        {/* Export button */}
        <button
          className={getButtonClass(isExportEnabled)}
          disabled={!isExportEnabled}
          onClick={handleExport}
          title={isLoading ? "מייצא..." : isExportEnabled ? "ייצוא" : ""}
          aria-label="ייצוא"
          tabIndex={isExportEnabled ? 0 : -1}
        >
          {isLoading ? (
            <img
              src={loadingIcon}
              alt="loading"
              className="h-5 w-5 object-cover"
            />
          ) : (
            <Upload className={iconClass} />
          )}
        </button>

        {/* Delete button */}
        <div className="relative group">
          <button
            className={getButtonClass(isDeleteEnabled)}
            disabled={!isDeleteEnabled}
            onClick={handleDelete}
            title={isLoading ? "ממחק..." : isDeleteEnabled ? "מחק" : ""}
            aria-label="מחק"
            tabIndex={isDeleteEnabled ? 0 : -1}
          >
            {isLoading ? (
              <img
                src={loadingIcon}
                alt="loading"
                className="h-5 w-5 object-cover"
              />
            ) : (
              <div className="relative flex items-center justify-center w-5 h-5">
                <div
                  className={`absolute inset-0 w-5 h-5 border-2 rounded-full ${
                    isDeleteEnabled ? "border-customBlue" : "border-gray-300"
                  }`}
                ></div>
                <X className="h-4 w-4 relative z-10" />
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapiToolbar;
